import { apiClient } from "features/shared/api/axiosInstance";

export const termsApi = {
    viewTermsAndConditionUrl: (type: string) =>
        apiClient.get<string>(`/api/organization-terms/view-url/${type}`),

    updateTermsAndConditions: (
        formData: { termsAndConditions?: File | null; personalDataTreatmentAuthorization?: File | null; privacyPolicy?: File | null },
    ) => {
        const data = new FormData();
        if (formData.termsAndConditions) data.append("termsAndConditions", formData.termsAndConditions);
        if (formData.personalDataTreatmentAuthorization)
            data.append("personalDataTreatmentAuthorization", formData.personalDataTreatmentAuthorization);
        if (formData.privacyPolicy) data.append("privacyPolicy", formData.privacyPolicy);
        return apiClient.post("/api/organization-terms/modify", data, {
            headers: { "Content-Type": "multipart/form-data" },
        });
    },
};